// Lift hub sign-in tokens out of the URL before anything else runs.
//
// This MUST stay the first import in main.jsx: ES modules evaluate in import
// order, so the tokens leave the address bar before any other code can read or
// report it. See utils/urlSecrets.js.
import { captureUrlSecrets } from './utils/urlSecrets.js';

captureUrlSecrets();
